import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import ReactHtmlParser from 'html-react-parser';
import { BlogPost, CategoryId } from '@/domain/entities/post';
import { BlogAuthor } from '@/domain/entities/author';
import { useSummary } from '@/hooks/use-summary';
import ShareButtons from '@/components/ShareButtons';

import { categories } from './categories';
import { Author, PostContainer, Breadcrumbs, Summary, PostWrapper } from './styles';

type PostContentProps = {
  post: BlogPost;
  author: BlogAuthor;
};

export default function PostContent({ post, author }: PostContentProps) {
  const postCategory: CategoryId = post.category;
  const { summarizer, summary } = useSummary();

  useEffect(() => {
    summarizer();
  }, []);

  return (
    <PostContainer>
      <h1>{post.title}</h1>
      <Author>
        <Image src={author.avatarUrl} alt={author.name} width={50} height={50} unoptimized />
        <p>
          Por <span className="name">{author.name}</span>
          <span className="date">
            {format(new Date(post.date), 'dd MMM yyyy', {
              locale: ptBR,
            })}
          </span>
          <span className="duration">{post.readingTime} min de leitura</span>
        </p>

        <Breadcrumbs>
          <Link href="/" legacyBehavior>
            <a>Inicio</a>
          </Link>
          <span className="separator"> » </span>
          <Link href={`/categorias/${categories[postCategory]?.slug ?? 'uncategorized'}`} legacyBehavior>
            <a>{categories[postCategory]?.name ?? 'Uncategorized'}</a>
          </Link>
        </Breadcrumbs>
      </Author>

      <PostWrapper>
        <Image src={post.media} alt="Imagem ilustrativa" width={700} height={200} unoptimized />

        {summary ? (
          <Summary>
            {summary.map((i, index) => (
              <a href={`#${i.id}`} key={index} className="summary-link">
                <span>{`${index + 1}.`}</span> {i.name}
              </a>
            ))}
          </Summary>
        ) : null}
        <div>{ReactHtmlParser(post.content ?? '')}</div>
        <ShareButtons slug={post.slug} />
      </PostWrapper>
    </PostContainer>
  );
}
